import ApiResponse from "../models/ApiResponse";
import api from "./api";

const baseURL = "https://api.midenas.rs"

export const sendMessage = async (contact: any) => {
    return api.post(baseURL + "/api/email", contact) as Promise<ApiResponse>;
};